/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { makeStyles, Typography, Grid, useMediaQuery } from '@material-ui/core';

import IconDvdLine from '../../assets/images/ic-dvdline.svg';
import IconRadiology from '../../assets/images/ic-radiology-report.svg';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    background: '#F5F5F5',
    borderRadius: '8px',
    cursor: 'pointer',
    padding: '16px',
    [theme.breakpoints.up('lg')]: {
      cursor: 'auto',
    },
  },
  buttonIcon: {
    height: 'auto',
    marginBottom: '10px ',
    width: '30px',
  },
  buttonText: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
    textAlign: 'center',
  },
  buttonViewText: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '19px',
    marginBottom: '0px',
    marginRight: '5px',
  },
  buttonViewTextDisabled: {
    color: '#999999 !important',
    cursor: 'not-allowed !important',
  },
  title: {
    color: '#172B4D',
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    marginBottom: '9px',
    textAlign: 'left',
  },
  viewContainer: {
    display: 'none',
  },
  [theme.breakpoints.up('lg')]: {
    buttonIcon: {
      height: 'auto',
      marginBottom: '0px',
      marginRight: '16px',
      width: '40px',
    },
    buttonText: {
      textAlign: 'left',
    },
    title: {
      marginBottom: '15px',
    },
    viewContainer: {
      display: 'block',
    },
  },
}));

export default ({ onViewReport, onViewStudy, caseDetails }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const isRadiologyImagesEnabled = caseDetails?.case?.viewerLink;

  const handleViewReport = () => {
    if (!onViewReport || typeof onViewReport !== 'function') return;
    onViewReport();
  };

  const handleViewStudy = () => {
    if (!onViewStudy || typeof onViewStudy !== 'function' || !isRadiologyImagesEnabled) return;
    onViewStudy();
  };

  const handleMobileClick = (fn) => {
    if (!fn || typeof fn !== 'function') return;
    fn();
  };

  return (
    <div>
      <Typography className={classes.title}>Supplied Files</Typography>
      <Grid container spacing={1}>
        <Grid item xs={6} lg={12}>
          <div onClick={() => handleMobileClick(handleViewStudy)} className={classes.buttonContainer}>
            <Grid container alignItems="center" justify={isDesktop ? 'space-between' : 'center'}>
              {/* Image and text */}
              <Grid item>
                <Grid alignItems="center" container>
                  <Grid item xs={!isDesktop && 12} style={{ lineHeight: '0px' }}>
                    <img className={classes.buttonIcon} src={IconDvdLine} alt="Mediphany Radiology" />
                  </Grid>
                  <Grid item xs={!isDesktop && 12}>
                    <Typography className={classes.buttonText}>Radiology Files</Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* View button */}
              <Grid item className={classes.viewContainer}>
                <Typography onClick={handleViewStudy} className={`${classes.buttonViewText} ${!isRadiologyImagesEnabled && classes.buttonViewTextDisabled}`}>
                  <u>View</u>
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={6} lg={12}>
          <div onClick={() => handleMobileClick(handleViewReport)} className={classes.buttonContainer}>
            <Grid container alignItems="center" justify={isDesktop ? 'space-between' : 'center'}>
              {/* Image and text */}
              <Grid item>
                <Grid alignItems="center" container>
                  <Grid item xs={!isDesktop && 12} style={{ lineHeight: '0px' }}>
                    <img className={classes.buttonIcon} src={IconRadiology} alt="Mediphany Radiology Report" />
                  </Grid>
                  <Grid item xs={!isDesktop && 12}>
                    <Typography className={classes.buttonText}>Radiology Report</Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* View button */}
              <Grid item className={classes.viewContainer}>
                <Typography onClick={handleViewReport} className={`${classes.buttonViewText}`}>
                  <u>View</u>
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
